import { isValidPhoneNumber } from "libphonenumber-js/min";
import { validatePhoneNumber } from "./validate-phone-number";

export const validateInternationalPhoneNumber = (value) => {
  if (typeof value !== "string") return false;

  const trimmed = value.trim();

  if (!trimmed) return false;
  if (trimmed.includes("*")) return true;
  if (!trimmed.startsWith("+")) return validatePhoneNumber(trimmed);

  return isValidPhoneNumber(trimmed);
};
